export default {
    namespaced: true,
    modules: {
        file: require("./file").default,
    },
    state: {
    },
};


// WEBPACK FOOTER //
// src/store/tool/index.js